






































import {Component, Vue} from 'vue-property-decorator'
import UserInfoView from "@/view/user-manage/user/info.vue";
import userModule from "@/store/module/UserModule";
import {Inject} from "typescript-ioc";
import UserApi from "@/api/UserApi";

@Component({
    components: {
        UserInfoView,
    },
})
export default class UserDetailView extends Vue {

    @Inject
    private userApi!: UserApi

    private leftColSpan = 2
    private rightColSpan = 10

    private get user() {
        return userModule.active
    }

    private async created() {
        const id = String(this.$route.query.id)
        const user = await this.userApi.detail(id)
        await userModule.activate(user)
    }

    private destroyed() {
        userModule.destroy()
    }
}
